enum TaxChangeStatus {
  ALL = 0,
  READY = 100,
  IN_PROGRESS = 200,
  FAILURE = 300,
  COMPLETE = 400,
  REFUND = 500,
  SEND = 600,
}

export const allCases = [TaxChangeStatus.ALL, TaxChangeStatus.IN_PROGRESS, TaxChangeStatus.COMPLETE];

export const colorOf = (state: number) => {
  switch (state) {
    case TaxChangeStatus.IN_PROGRESS:
    case TaxChangeStatus.COMPLETE:
    case TaxChangeStatus.SEND:
      return 'success';
    case TaxChangeStatus.FAILURE:
      return 'error';
    default:
      return 'default';
  }
};

export const messageOf = (state: number) => {
  switch (state) {
    case TaxChangeStatus.ALL:
      return '전체';
    case TaxChangeStatus.IN_PROGRESS:
      return '신청 완료';
    case TaxChangeStatus.FAILURE:
      return '접수 실패';
    case TaxChangeStatus.COMPLETE:
      return '접수 완료';
    case TaxChangeStatus.REFUND:
      return '환불 완료';
    case TaxChangeStatus.SEND:
      return '신청 완료';
    default:
      return '준비 중';
  }
};

export default TaxChangeStatus;
